import { BaseDto } from './base.dto';
import { BrandDto } from './brand.dto';
import { ModifierGroupModifierDto } from './modifierGroupModifier.dto';
import { ModifierDto } from './modifier.dto';

export class ModifierGroupDto extends BaseDto {
  name: string;
  enabled?: boolean;
  brandId?: number;
  brand?: BrandDto;
  minRequired: number;
  maxAllowed: number;
  modifierGroupModifier: ModifierGroupModifierDto[];
  merchantId?: number;
  sharedSourceName?: string;
  tag: string;
  colorCode?: string;
  modifiers?: ModifierDto[];
}
